import React from 'react';
import { Header, Icon, Button } from 'semantic-ui-react';
import { IdeaCompanyVerification } from 'components/lib/Ideas';
import CompanyVerificationReportGenerator from 'components/lib/CompanyVerificationReportGenerator';
import toast from 'react-hot-toast';
import { BodySegment } from './styles';

const CompanyReport = ({
  user,
  field,
  ideaId,
  fieldValue = '',
  updateIdea,
  isEditing,
}) => {
  if (!isEditing) {
    if (fieldValue) return <IdeaCompanyVerification idea={{ _id: ideaId }} report={fieldValue} />;
    return null;
  }
  return (
    <BodySegment placeholder textAlign="center">
      {!fieldValue
        ? (
          <>
            <Header icon>
              <Icon name="building" />
              {' '}
              Company lookup
            </Header>
            <CompanyVerificationReportGenerator
              user={user}
              trigger={(<Button primary content="Find your company" />)}
              forType="idea"
              forId={ideaId}
              onComplete={(report) => {
                const { tempReportUrl } = report;
                delete report.tempReportUrl;
                updateIdea({ report: report._id, ...report }, ['templated', field.id]);
                updateIdea({ report: report._id, ...report, reportUrl: tempReportUrl }, ['templated', field.id], true);
              }}
              onError={toast.error}
            />
          </>
        ) : (
          <div style={{ marginTop: 20 }}>
            <IdeaCompanyVerification
              idea={{ _id: ideaId }}
              report={fieldValue}
            />
            <Button
              size="small"
              style={{ marginTop: 15 }}
              basic
              icon="close"
              color="orange"
              content="Use a different company"
              onClick={() => updateIdea(null, ['templated', field.id])}
            />
          </div>
        )
      }
    </BodySegment>
  );
};

export default CompanyReport;
